import { AccessorType } from '../models/accessor.type';
import { LineConfig } from './config/line.config';
import { DataColumn } from './data-column';

export class DataPointScaled
{
    constructor (public xScaled: number, public yScaled: number, public color: string, public radius: number)
    {
    }
}

export class Serie
{
    id: number;
    isVisible: boolean;
    label: string;
    config: LineConfig;
    dataPoints: any[];
    dpScaled: DataPointScaled[];
    xRawAccessor: AccessorType;
    xAccessor: AccessorType;
    yAccessor: AccessorType;
    xAccessorScaled?: AccessorType;
    yAccessorScaled?: AccessorType;
    y0AccessorScaled?: AccessorType;
    radius: number = 4;
    unit: string;
    drawNullPoint: boolean;

    public static getSeriesFromDataColumn (dataColumn: DataColumn) : Serie[]
    {
        const series = dataColumn.keys.map((key, index): Serie =>
        {
            return {
                id: index,
                isVisible: true,
                label: dataColumn.labels[index],
                config: {
                    color: dataColumn.colors[index],
                    width: 1
                },
                dataPoints: dataColumn.points.map(p => ({ x: p.x, value: p.values.get(key) })),
                unit: '%',
                drawNullPoint: true
            } as Serie;
        });

        return series;
    }
}
